import React from 'react';
import { Link } from "react-router-dom";
import Auth from "../../services/Auth.service";
import { useTranslation } from "react-i18next";
import NavegacionFarms from "../../components/NavigableComponents/NavigableFarms";
import BotonesNavegacionNaves from "../../components/ButtonComponentsPanel/CustomButtonsRedirectShips";
import NavesInformationComponents from "../../components/NavesComponents/NavesInformationComponents";

export default function InformationNaves() {

    const { t } = useTranslation();

    return (
        <div>
            {Auth.isUserLoged ? <div>
                <br />
                <div className="container-fluid">
                    <div className="col-12 col-lg-11 mx-auto">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to={'/home/'}>{t("Home_Breadcrumb_Title")}</Link></li>
                                    <li className="breadcrumb-item"><Link to={'/Groups/'}>{t("Global_Label_Text_Groups")}</Link></li>
                                    <li className="breadcrumb-item"><Link to={'/Naves/'}>{t("Global_Label_Text_Ships")}</Link></li>
                                    <li className="breadcrumb-item"><Link to={'/InformationNaves/'}>{t("Global_Label_Text_Information")}</Link></li>
                                </ol>
                            </nav>
                            <NavegacionFarms />
                        </div>
                    </div>
                </div>

                <div>
                    <div>
                        <BotonesNavegacionNaves />
                    </div>

                    <div>
                        <NavesInformationComponents />

                    </div>

                </div>
                <br />
            </div > : ""}
        </div>
    );

}
